export const themes = [
  {
    id: 1,
    name: "lime",
    body: "#274a2b",
    textPrimary: "text-green-100",
    textSecondary: "text-green-200",
    border: "border-b-green-200",
    activeTogglerOutline: "border-green-300",
  },
  {
    id: 2,
    name: "mahogany",
    body: "#3b1f12",
    textPrimary: "text-red-100",
    textSecondary: "text-orange-100",
    border: "border-b-red-200",
    activeTogglerOutline: "border-red-300",
  },
  {
    id: 3,
    name: "charcoal",
    body: "#36454F",
    textPrimary: "text-blue-100",
    textSecondary: "text-blue-200",
    border: "border-b-blue-200",
    activeTogglerOutline: "border-blue-300",
  },
];
